// FivePointPlaneMarker.js
import { GalleryMarkerBase } from './GalleryMarkerBase.js';

// Read-only Viewpoint mit 5 Punkten (Fläche): nur der Origin-Marker. Die Fläche zeichnet die zentrale LocationShapeLayer.
// Früher: zwei google.maps.Polygon im overlayLayer (unter den Overlays).
export class FivePointPlaneMarker extends GalleryMarkerBase {
    draw(map) {
        if (this.points.length !== 5) return;
        const latLng = this.mapAdapter.createLatLng(this.points[0].lat, this.points[0].lng);
        const marker = this.createOriginMarker(latLng);
        this.drawnElements.push(marker);
    }
}
